import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  currentPage: 1,
  pageSize: 10,
  searchQuery: "",
};

export const vehicleManagementSlice = createSlice({
  name: "vehicleManagement",
  initialState,
  reducers: {
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    },
    setPageSize: (state, action) => {
      state.pageSize = action.payload;
    },
    setSearchQuery: (state, action) => {
      state.searchQuery = action.payload;
    },
    resetVehicleManagementState: (state) => {
      state.currentPage = 1;
      state.pageSize = 10;
      state.searchQuery = "";
    },
  },
});

export const {
  setCurrentPage,
  setPageSize,
  setSearchQuery,
  resetVehicleManagementState,
} = vehicleManagementSlice.actions;

export default vehicleManagementSlice.reducer;
